<template>
  <section class="web-content-page">
    <h1>Web Content</h1>
    <div class="main-container">
      <div class="aside">
        <ul>
          <li
            v-for="(item, index) in list"
            :key="index"
            :class="{ 'active': item.value === activeTab }"
            @click="onTab(index)">{{ item.label }}</li>
        </ul>
      </div>
      <div class="main-content">
        <news v-show="activeTab == 'Blog'" />
        <banner v-show="activeTab == 'Home'"  />
        <!-- <promos v-show="activeTab == 'Promos'" /> -->
        <notice v-show="activeTab == 'Notice'" />
        <coupons v-show="activeTab == 'Coupons'" />
        <promotions v-show="activeTab == 'Promotions'"/>
        <blog-ad v-show="activeTab == 'BlogAd'" />
      </div>
    </div>
  </section>
</template>
<script>
import News from './components/webcontent/news'
import Banner from './components/webcontent/banner'
// import Promos from './components/webcontent/promos'
import Notice from './components/webcontent/notice'
import Coupons from './components/webcontent/coupons'
import Promotions from './components/webcontent/promotions.vue'
import BlogAd from './components/webcontent/blog-ad'
import {mapActions,mapState} from 'vuex'

export default {
  name: 'WebContentPage',
  components: {
    News,
    Banner,
    // Promos,
    Notice,
    Coupons,
    Promotions,
    BlogAd
  },
  data() {
    return {
      active: 1,
      activeTab: 'Blog',
      list: [
        {
          label: 'Home',
          value: 'Home'
        },
        {
          label: 'Blog',
          value: 'Blog'
        },
        {
          label: 'Promotions',
          value: 'Promotions'
        },
        // {
        //   label: 'Promos',
        //   value: 'Promos'
        // },
        {
          label: 'Referral',
          value: 'Referral'
        },
        {
          label: 'Notice',
          value: 'Notice'
        },
        {
          label: 'Coupons',
          value: 'Coupons'
        },
        {
          label: 'Footer',
          value: 'Footer'
        },
        {
          label: 'Blog Ad Report',
          value: 'BlogAd'
        }
      ],
    }
  },
  computed:{
    ...mapState('coupon', ['getActiveTab']),
  },
  watch: {
    property: {
      immediate: true,
      handler() {
        const { tab } = this.$route.query
        if(tab) {
          this.activeTab = tab
        }
      }
    },
    getActiveTab:{
      immediate: true,
      handler(val) {
        if(val){
          this.activeTab =val
        }else{
          this.activeTab = this.list[0].value
        }
      }
    }
  },
  methods: {
    ...mapActions('coupon', ['setActiveTab']),
    onTab(index) {
      this.active = index
      this.activeTab = this.list[index].value
      this.setActiveTab (this.list[index].value)

    }
  }
}
</script>
<style lang="scss" scoped>
.web-content-page {
  position: relative;
  // padding: 15px;
  .main-container {
    display: flex;
    .aside {
      margin-right: 20px;
      ul {
        li {
          padding: 10px;
          min-width: 100px;
          list-style: none;
          color: #409EFF;
          font-size: 16px;
          font-weight: 500;
          cursor: pointer;
          &.active, &:hover {
            background: #ecf5ff;
          }
        }
      }
    }
    .main-content {
      flex: 1;
    }
  }
}
</style>